import { Box, Typography, Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";

export default function Summary({ children }) {
  const ref = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);
  const [atBottom, setAtBottom] = useState(false);

  const checkOverflow = () => {
    const el = ref.current;
    if (!el) return;

    setHasOverflow(el.scrollHeight > el.clientHeight);
    setAtBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - 1);
  };

  useEffect(() => {
    checkOverflow();
  }, [children]);

  return (
    <Box
      sx={{
        position: "relative",
        flex: 1,
        overflow: "hidden",
      }}
    >
      {/* Scrollable content */}
      <Box
        ref={ref}
        onScroll={checkOverflow}
        sx={{
          height: "100%",
          overflowY: "auto",
          px: 2,
          py: 1,
        }}
      >
        {children}
      </Box>

      {/* Read more overlay */}
      {hasOverflow && !atBottom && (
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: 64,
            background:
              "linear-gradient(to top, #ffffffff 60%, transparent)",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            pb: 1,
            pointerEvents: "none",
          }}
        >
          <Button
            size="small"
            sx={{
              pointerEvents: "auto",
              color: "black",
              textTransform: "none",
            }}
            onClick={() => {
              const el = ref.current;
              el.scrollTo({
                top: el.scrollHeight,
                behavior: "smooth",
              });
            }}
          >
            Read more
          </Button>
        </Box>
      )}
    </Box>
  );
}
